import React from 'react';
import styles from './Products.module.scss';
import { TabsLabels, TabsKeys } from 'enums/ProductsViewEnums';
import clsx from 'clsx';
import Brands from 'shared/components/Products/Brands';
import { ReactComponent as ProductLogo } from 'assets/icons/product.svg';
import { ReactComponent as Review } from 'assets/icons/search.svg';
import { ReactComponent as Verified } from 'assets/icons/verified.svg';
import { ReactComponent as Draft } from 'assets/icons/draft.svg';
import { ReactComponent as Declined } from 'assets/icons/declined.svg';
import { ReactComponent as Brand } from 'assets/icons/brand.svg';
import AllProducts from 'shared/components/Products/AllProducts';
import InReviewProducts from 'shared/components/Products/InReviewProducts';
import DraftProducts from 'shared/components/Products/DraftProducts';
import VerifiedProducts from 'shared/components/Products/VerifiedProducts';
import DeclinedProducts from 'shared/components/Products/DeclinedProducts';
import { ProcessingFacility } from 'models/ProcessingFacility/ProcessingFacility.model';

interface getTabsProps {
  isActiveTab: (tab: string) => boolean;
  handleTabChange: (tab: string) => void;
  showBrandModal: boolean
  setShowBrandModal: (value: boolean) => void,
  processingFacilityList:ProcessingFacility[];
  setCreateProcessingFacility:React.Dispatch<React.SetStateAction<boolean>>
}
export const getTabs = ({ isActiveTab, handleTabChange, showBrandModal, setShowBrandModal, processingFacilityList, setCreateProcessingFacility }: getTabsProps) => {
  return [
    {
      children: <AllProducts processingFacilityList={processingFacilityList} handleModalOpen={setCreateProcessingFacility} />,
      active: isActiveTab(TabsKeys.ALL_PRODUCTS),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.ALL_PRODUCTS),
          })}
          onClick={() => handleTabChange(TabsKeys.ALL_PRODUCTS)}>
          <ProductLogo
            className={clsx({
              [styles.icon]: isActiveTab(TabsKeys.ALL_PRODUCTS),
            })}
          />
          {TabsLabels.ALL_PRODUCTS}
        </span>
      ),
      key: TabsKeys.ALL_PRODUCTS,
    },
    {
      children: <InReviewProducts processingFacilityList={processingFacilityList} handleModalOpen={setCreateProcessingFacility} />,
      active: isActiveTab(TabsKeys.IN_REVIEW),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.IN_REVIEW),
          })}
          onClick={() => handleTabChange(TabsKeys.IN_REVIEW)}>
          <Review
            className={clsx({
              [styles.icon]: isActiveTab(TabsKeys.IN_REVIEW),
            })}
          />
          {TabsLabels.IN_REVIEW}
        </span>
      ),
      key: TabsKeys.IN_REVIEW,
    },
    {
      children: <VerifiedProducts processingFacilityList={processingFacilityList} handleModalOpen={setCreateProcessingFacility} />,
      active: isActiveTab(TabsKeys.APPROVED),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.APPROVED),
          })}
          onClick={() => handleTabChange(TabsKeys.APPROVED)}>
          <Verified
            className={clsx({
              [styles.icon]: isActiveTab(TabsKeys.APPROVED),
            })}
          />
          {TabsLabels.APPROVED}
        </span>
      ),
      key: TabsKeys.APPROVED,
    },
    {
      children: <DraftProducts processingFacilityList={processingFacilityList} handleModalOpen={setCreateProcessingFacility} />,
      active: isActiveTab(TabsKeys.DRAFT),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.DRAFT),
          })}
          onClick={() => handleTabChange(TabsKeys.DRAFT)}>
          <Draft
            className={clsx({
              [styles.icon]: isActiveTab(TabsKeys.DRAFT),
            })}
          />
          {TabsLabels.DRAFT}
        </span>
      ),
      key: TabsKeys.DRAFT,
    },
    {
      children: <DeclinedProducts processingFacilityList={processingFacilityList} handleModalOpen={setCreateProcessingFacility} />,
      active: isActiveTab(TabsKeys.DECLINED),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.DECLINED),
          })}
          onClick={() => handleTabChange(TabsKeys.DECLINED)}>
          <Declined
            className={clsx({
              [styles.icon]: isActiveTab(TabsKeys.DECLINED),
            })}
          />
          {TabsLabels.DECLINED}
        </span>
      ),
      key: TabsKeys.DECLINED,
    },
    {
      children: <Brands
        showBrandModal={showBrandModal}
        setShowBrandModal={setShowBrandModal}
      />,
      active: isActiveTab(TabsKeys.BRANDS),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.BRANDS),
          })}
          onClick={() => handleTabChange(TabsKeys.BRANDS)}>
          <Brand
            className={clsx({
              [styles.icon]: isActiveTab(TabsKeys.BRANDS),
            })}
          />
          {TabsLabels.BRANDS}
        </span>
      ),
      key: TabsKeys.BRANDS,
    },
  ];
};
